export enum PackageWeightEnum {
    SMALL = 'SMALL',    // 0-10 kg
    LARGE = 'LARGE'     // 10 kg - 30 kg
}
